export const storage_key = {
  jwt_token: "accessToken",
  refresh_token: "refreshToken",
};
